export default __webpack_public_path__ + "static/media/img-0002.4a1ae5b0.png";